import React from 'react';
import { Box, BoxProps } from '@hover/blueprint';
import HomeOwnerMessage from './HomeOwnerMessage';
import ContractorMessage from './ContractorMessage';

interface Props extends BoxProps {
  contractorMessage: string;
  homeOwnerMessage: string;
}

const ContractorHomeOwnerMessagePair: React.FC<Props> = ({
  homeOwnerMessage,
  contractorMessage,
  ...restProps
}) => (
  <Box
    h="100%"
    {...restProps}
    flexDir="column"
    w={{ base: '100%', tablet: '540px' }}
    maxW="540px"
    position="absolute"
  >
    <Box className="contractor-message" transformOrigin="0 50%">
      <ContractorMessage
        top={0}
        left={0}
        position="absolute"
        message={contractorMessage}
      />
    </Box>
    <Box className="homeowner-message" transformOrigin="-5px 0">
      <HomeOwnerMessage
        top={{ base: '97px', tablet: '56px' }}
        right={0}
        position="absolute"
        message={homeOwnerMessage}
      />
    </Box>
  </Box>
);

export default ContractorHomeOwnerMessagePair;
